// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
    cursor: pointer;
}
.ContactForm_container__rWHKb {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #181818;
    color: #fff;
    padding: 20px;
    max-width: 1200px;
    margin: auto;
  }
  
  .ContactForm_formContainer__9w1QA {
    max-width: 540px;
    background: #222;
    padding: 35px;
    border-radius: 8px;
  }
  
.ContactForm_formContainer__9w1QA input {
    width: 94% ;
    margin-top: 7px;
    background: #333;
    color: white;
    border: none;
    border-radius: 4px;
    min-height: 47px;
    padding: 0px 17px;
  }
.ContactForm_formContainer__9w1QA select {
    width: 100%;
    padding: 15px;
    margin-top: 9px;
    background: #333;
    color: white;
    border: none;
    border-radius: 4px;
  }
.ContactForm_formContainer__9w1QA textarea {
    width: 100%;
    padding: 15px 0px;
    margin-top: 9px;
    background: #333;
    color: white;
    border: none;
    border-radius: 4px;
  }
.ContactForm_formContainer__9w1QA button {
    width: 100%;
    padding: 10px;
    background: red;
    border: none;
    color: white;
    font-size: 16px;
    margin-top: 10px;
    cursor: pointer;
  }
  
  .ContactForm_infoContainer__GXIHi {
    margin-top: 20px;
    padding: 20px;
    border-radius: 8px;
 }
  .ContactForm_iconss__CRAMr{
    color: red;
  }
  .ContactForm_icons__l-\\+GQ svg {
    margin: 0 10px;
    cursor: pointer;
  }
.ContactForm_contactInfo__w8SsD{
    background: #222;
    padding: 3rem;
    margin-bottom: 10px;
    border-radius: 15px;
}
.ContactForm_socials__zxL8K{
    background: #222;
    padding: 3rem;
    border-radius: 15px;
}
  
  /* Responsive Design */
  @media (min-width: 768px) {
    .ContactForm_container__rWHKb {
      flex-direction: row;
      justify-content: space-between;
    }
    .ContactForm_formContainer__9w1QA, .ContactForm_infoContainer__GXIHi {
      width: 45%;
    }
  }
  @media (max-width: 400px) {
  .ContactForm_formContainer__9w1QA input {
    width: 88% !important;
    }
  }
    `, "",{"version":3,"sources":["webpack://./src/pages/Aboutus/ContactForm.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;EACpB;;AAEF;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;AACF;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;AACF;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,kBAAkB;CACrB;EACC;IACE,UAAU;EACZ;EACA;IACE,cAAc;IACd,eAAe;EACjB;AACF;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;EAEE,sBAAsB;EACtB;IACE;MACE,mBAAmB;MACnB,8BAA8B;IAChC;IACA;MACE,UAAU;IACZ;EACF;EACA;EACA;IACE,qBAAqB;IACrB;EACF","sourcesContent":["button {\n    cursor: pointer;\n}\n.container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: #181818;\n    color: #fff;\n    padding: 20px;\n    max-width: 1200px;\n    margin: auto;\n  }\n  \n  .formContainer {\n    max-width: 540px;\n    background: #222;\n    padding: 35px;\n    border-radius: 8px;\n  }\n  \n.formContainer input {\n    width: 94% ;\n    margin-top: 7px;\n    background: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    min-height: 47px;\n    padding: 0px 17px;\n  }\n.formContainer select {\n    width: 100%;\n    padding: 15px;\n    margin-top: 9px;\n    background: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n  }\n.formContainer textarea {\n    width: 100%;\n    padding: 15px 0px;\n    margin-top: 9px;\n    background: #333;\n    color: white;\n    border: none;\n    border-radius: 4px;\n  }\n.formContainer button {\n    width: 100%;\n    padding: 10px;\n    background: red;\n    border: none;\n    color: white;\n    font-size: 16px;\n    margin-top: 10px;\n    cursor: pointer;\n  }\n  \n  .infoContainer {\n    margin-top: 20px;\n    padding: 20px;\n    border-radius: 8px;\n }\n  .iconss{\n    color: red;\n  }\n  .icons svg {\n    margin: 0 10px;\n    cursor: pointer;\n  }\n.contactInfo{\n    background: #222;\n    padding: 3rem;\n    margin-bottom: 10px;\n    border-radius: 15px;\n}\n.socials{\n    background: #222;\n    padding: 3rem;\n    border-radius: 15px;\n}\n  \n  /* Responsive Design */\n  @media (min-width: 768px) {\n    .container {\n      flex-direction: row;\n      justify-content: space-between;\n    }\n    .formContainer, .infoContainer {\n      width: 45%;\n    }\n  }\n  @media (max-width: 400px) {\n  .formContainer input {\n    width: 88% !important;\n    }\n  }\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ContactForm_container__rWHKb`,
	"formContainer": `ContactForm_formContainer__9w1QA`,
	"infoContainer": `ContactForm_infoContainer__GXIHi`,
	"iconss": `ContactForm_iconss__CRAMr`,
	"icons": `ContactForm_icons__l-+GQ`,
	"contactInfo": `ContactForm_contactInfo__w8SsD`,
	"socials": `ContactForm_socials__zxL8K`
};
export default ___CSS_LOADER_EXPORT___;
